import { connect } from 'react-redux'

import HiringStatus from 'modules/Report/Partials/HiringStatus/index.js'
import {
  cityDetails,
  tierDetails,
  collegeDetails,
  roleDetails,
  getApplicationDriveLevel,
  roundDetails,
  courseTypeDetails,
  degreeDetails,
  hiringLevelDetails,
} from 'modules/Report/action.js'
import reportSelectors from 'modules/Report/selectors.js'
import authSelector from 'modules/Auth/selectors'
const mapStateToProps = state => ({
  cityData: reportSelectors.getCityData(state),
  tierData: reportSelectors.getTierData(state),
  collegeData: reportSelectors.getCollegeData(state),
  roleData: reportSelectors.getRoleData(state),
  roundData: reportSelectors.getRoundData(state),
  degreeData: reportSelectors.getDegreeData(state),
  courseTypeData: reportSelectors.getCourseTypeData(state),
  rolesPublishedData: reportSelectors.getHiringLevelData(state),
  excelDataForReport: reportSelectors?.excelData(state),
  corporateData: authSelector.getCorporateData(state),
})

const mapDispatchToProps = {
  cityDetails,
  tierDetails,
  getApplicationDriveLevel,
  collegeDetails,
  roleDetails,
  roundDetails,
  courseTypeDetails,
  degreeDetails,
  hiringLevelDetails,
}

export default connect(mapStateToProps, mapDispatchToProps)(HiringStatus)
